import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { filter, join } from 'lodash';
import { PayerError } from '../utils/errors';

export type PayerErrorMessageProps = {
  error: PayerError;
};

export const PayerErrorMessage = ({ error }: PayerErrorMessageProps): ReactElement | null => {
  const { t } = useTranslation();
  if (!error) return null;
  // .detail is actually stored in .stack, because createAsyncThunk() only supports some error field names
  const { code, message, stack: detail } = error;

  let text;
  if (code && message) text = t(code, `code ${code}: ${message}`);
  if (code && !message) text = t(code, `code ${code}`);
  if (!code && message) text = message;
  if (!code && !message) text = t('error.missingErrorCode');

  return <>{join(filter([text, detail]), ': ')}</>;
};
